import { colors } from '@workday/canvas-kit-react'
import React, { useEffect } from 'react'

declare global {
  interface Window {
    adsbygoogle: any[]
  }
}

interface AdSenseProps {
  adClient: string
  adSlot: string
  adFormat?: string
  style?: React.CSSProperties
  className?: string
  layout?: string
}

export const AdSense = ({
  adClient,
  adSlot,
  adFormat = 'fluid',
  style,
  className,
  layout
} : AdSenseProps) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error)
    }
  }, [])

  return (
    <ins
      className={`adsbygoogle ${className || ''}`}
      style={{ 
        display: 'block', 
        borderBottom: `1px solid ${colors.soap600}`, 
        ...style 
      }}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-layout-key={layout}
      data-ad-format={adFormat}
    />
  )
}
